import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import productoService from "../services/productoService";
import { message } from "utils/Funciones";

const initialState = {
    responseSuccessCreate: null,
    responseSuccessGet: null,
    responseSuccessUpdate: null,
    responseSuccessDelete: null,
    data: [],
    dataByPage: [],
    dataByPageProd: [],
    dataByPageServ: [],
    totalRow: 0,
    totalRowProd: 0,
    totalRowServ: 0,
    total: 0,
    totalProd: 0,
    totalServ: 0,
    totalPage: 0,
    totalPageProd: 0,
    totalPageServ: 0,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: "",
    totalStoreValue: 0
};

export const create = createAsyncThunk(
    "producto/create",
    async (data, thunkAPI) => {
        try {
            return await productoService.create(data.formData, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const get = createAsyncThunk(
    "producto/get",
    async (token, thunkAPI) => {
        try {
            return await productoService.get(token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const getByPage = createAsyncThunk(
    "producto/getByPage/bypage",
    async (data, thunkAPI) => {
        try {
            return await productoService.getByPage(data.query, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const getByPageProd = createAsyncThunk(
    "producto/getByPageProd/bypageprod",
    async (data, thunkAPI) => {
        try {
            return await productoService.getByPageProd(data.query, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const getByPageServ = createAsyncThunk(
    "producto/getByPageServ/bypageserv",
    async (data, thunkAPI) => {
        try {
            return await productoService.getByPageServ(data.query, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);


export const getKardexByPageProd = createAsyncThunk(
    "producto/getKardexByPageProd/getkardexbypageprod",
    async (data, thunkAPI) => {
        try {
            return await productoService.getKardexByPageProd(data.query);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const getKardexByPageProdId = createAsyncThunk(
    "producto/getKardexByPageProdId/getkardexbypageprodId",
    async (data, thunkAPI) => {
        try {
            return await productoService.getKardexByPageProdId(data.query);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const update = createAsyncThunk(
    "producto/update/producto",
    async (data, thunkAPI) => {
        try {
            return await productoService.update(data.formData, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const del = createAsyncThunk(
    "producto/del",
    async (data, thunkAPI) => {
        try {
            return await productoService.del(data._id, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

const productoSlice = createSlice({
    name: "producto",
    initialState,
    reducers: {
        SET_TO_DEFAULT_RESPONSE(state, action) {
            state.responseSuccessCreate = null
            state.responseSuccessGet = null
            state.responseSuccessUpdate = null
            state.responseSuccessDelete = null
        },
        UPDATE_STOCK_PRODUCT(state, action) {
            const newState = state.dataByPage.map(item => {
                let itemsCart = action.payload.cartItems.find(cart => cart.product._id === item._id);
                if (itemsCart) {
                    return {
                        ...item,
                        stock: itemsCart.tipo === 'producto' ? item.stock - itemsCart.quantity : 0,
                        vendido: item.vendido + itemsCart.quantity
                    }
                }
                return item
            });

            state.dataByPage = newState
        },

        UPDATE_STOCK_PRODUCT_B(state, action) {
            const newState = state.dataByPage.map(item => {
                let itemsCart = action.payload.cartItems.find(cart => cart.product._id === item._id);
                if (itemsCart) {
                    const prod = item;

                    const previousStock = prod.stock || 0;
                    const previousPrice = prod.preciocompra || 0;
                    const newQuantity = itemsCart.quantity;
                    const newPriceUnit = itemsCart.price_unit;

                    const totalOld = previousStock * previousPrice;
                    const totalNew = newQuantity * newPriceUnit;
                    const totalStock = previousStock + newQuantity;

                    const newAveragePrice = totalStock > 0 ? (totalOld + totalNew) / totalStock : newPriceUnit;
                    return {
                        ...item,
                        stock: itemsCart.tipo === 'producto' ? item.stock + itemsCart.quantity : 0,
                        preciocompra: item.tipo === 'producto' ? newAveragePrice : previousPrice,
                        comprado: item.comprado + itemsCart.quantity
                    }
                }
                return item
            });

            state.dataByPage = newState
        },

        UPDATE_PRODUCTO_FROM_SOCKET(state, action) {


        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(create.pending, (state) => {
                //state.isLoading = true;
            })
            .addCase(create.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.responseSuccessCreate = action.payload;
            })
            .addCase(create.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(get.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(get.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.data = action.payload;
            })
            .addCase(get.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(getByPage.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getByPage.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.dataByPage = action.payload.data;
                state.totalPage = action.payload.totalPage;
                state.totalRow = action.payload.totalRow;
                state.total = action.payload.total;
                state.responseSuccessGet = action.payload;
            })
            .addCase(getByPage.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            // BYPAGE_PROD

            .addCase(getByPageProd.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getByPageProd.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.dataByPageProd = action.payload.data;
                state.totalPageProd = action.payload.totalPage;
                state.totalRowProd = action.payload.totalRow;
                state.totalProd = action.payload.total;
                state.responseSuccessGet = action.payload;
            })
            .addCase(getByPageProd.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })

            // BYPAGE_SERV

            .addCase(getByPageServ.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getByPageServ.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.dataByPageServ = action.payload.data;
                state.totalPageServ = action.payload.totalPage;
                state.totalRowServ = action.payload.totalRow;
                state.totalServ = action.payload.total;
                state.responseSuccessGet = action.payload;
            })
            .addCase(getByPageServ.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })

            .addCase(update.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(update.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.responseSuccessUpdate = action.payload;
                if (action.payload.newStateData.newData.tipo === 'producto') {
                    const newState = state.dataByPageProd.map((item) => {
                        if (item._id === action.payload.newStateData.newData._id) {
                            return {
                                ...item,
                                name: action.payload.newStateData.newData.name,
                                detalles: action.payload.newStateData.newData.detalles,
                                categoria: action.payload.newStateData.newData.categoria,
                                marca: action.payload.newStateData.newData.marca,
                                almacen: action.payload.newStateData.newData.almacen,
                                medida: action.payload.newStateData.newData.medida,
                                stock: action.payload.newStateData.newData.stock,
                                precioventa: action.payload.newStateData.newData.precioventa,
                                preciocompra: action.payload.newStateData.newData.preciocompra,
                                preciomayor: action.payload.newStateData.newData.preciomayor,
                                preciodistrubuidor: action.payload.newStateData.newData.preciodistrubuidor,
                                imagen: action.payload.newStateData.newData.imagen,
                                disabled: action.payload.newStateData.newData.disabled,
                                last_update: action.payload.newStateData.newData.last_update
                            }
                        }
                        return item
                    })
                    state.dataByPageProd = newState
                } else if (action.payload.newStateData.newData.tipo === 'servicio') {
                    const newState = state.dataByPageServ.map((item) => {
                        if (item._id === action.payload.newStateData.newData._id) {
                            return {
                                ...item,
                                name: action.payload.newStateData.newData.name,
                                detalles: action.payload.newStateData.newData.detalles,
                                categoria: action.payload.newStateData.newData.categoria,
                                marca: action.payload.newStateData.newData.marca,
                                almacen: action.payload.newStateData.newData.almacen,
                                medida: action.payload.newStateData.newData.medida,
                                stock: action.payload.newStateData.newData.stock,
                                precioventa: action.payload.newStateData.newData.precioventa,
                                preciocompra: action.payload.newStateData.newData.preciocompra,
                                preciomayor: action.payload.newStateData.newData.preciomayor,
                                preciodistrubuidor: action.payload.newStateData.newData.preciodistrubuidor,
                                imagen: action.payload.newStateData.newData.imagen,
                                disabled: action.payload.newStateData.newData.disabled,
                                last_update: action.payload.newStateData.newData.last_update
                            }
                        }
                        return item
                    })
                    state.dataByPageServ = newState
                } else {
                    const newState = state.dataByPage.map((item) => {
                        if (item._id === action.payload.newStateData.newData._id) {
                            return {
                                ...item,
                                name: action.payload.newStateData.newData.name,
                                detalles: action.payload.newStateData.newData.detalles,
                                categoria: action.payload.newStateData.newData.categoria,
                                marca: action.payload.newStateData.newData.marca,
                                almacen: action.payload.newStateData.newData.almacen,
                                medida: action.payload.newStateData.newData.medida,
                                stock: action.payload.newStateData.newData.stock,
                                precioventa: action.payload.newStateData.newData.precioventa,
                                preciocompra: action.payload.newStateData.newData.preciocompra,
                                preciomayor: action.payload.newStateData.newData.preciomayor,
                                preciodistrubuidor: action.payload.newStateData.newData.preciodistrubuidor,
                                imagen: action.payload.newStateData.newData.imagen,
                                disabled: action.payload.newStateData.newData.disabled,
                                last_update: action.payload.newStateData.newData.last_update
                            }
                        }
                        return item
                    })
                    state.dataByPage = newState
                }
            })
            .addCase(update.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })

            .addCase(del.pending, (state) => {
                //state.isLoading = true;
            })
            .addCase(del.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.responseSuccessDelete = action.payload;
            })
            .addCase(del.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
    },
});

export const { UPDATE_PRODUCTO_FROM_SOCKET, SET_TO_DEFAULT_RESPONSE, UPDATE_STOCK_PRODUCT, UPDATE_STOCK_PRODUCT_B } = productoSlice.actions;

export default productoSlice.reducer;

